import './App.css';
import React, { Suspense, lazy } from 'react';

const Minimalist = lazy(() => import('./components/Minimalist'));

function App() {
  return (
    <Suspense
      fallback={
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-slate-50 text-slate-600 dark:bg-slate-950 dark:text-slate-400">
          <div
            className="h-10 w-10 animate-spin rounded-full border-2 border-blue-600 border-t-transparent dark:border-blue-400"
            aria-hidden
          />
          <p className="text-sm font-medium">Loading…</p>
        </div>
      }
    >
      <Minimalist />
    </Suspense>
  );
}

export default App;
